// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import { Col, Row, Table, Badge, Button, Card, Spinner } from 'react-bootstrap';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';

// function SalesMDView() {
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [isLoading, setIsLoading] = useState(true);
//     const [salesData, setSalesData] = useState(null);

//     // Helper functions
//     const formatDate = (dateString) => {
//         if (!dateString) return '-';
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-IN');
//     };

//     const formatCurrency = (amount) => {
//         if (amount === null || amount === undefined) return '-';
//         return new Intl.NumberFormat('en-IN', {
//             style: 'currency',
//             currency: 'INR',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount);
//     };

//     const getStatusBadge = (status) => {
//         switch (status) {
//             case 'Draft': return <Badge bg="secondary">Draft</Badge>;
//             case 'Open': return <Badge bg="primary">Open</Badge>;
//             case 'Completed': return <Badge bg="success">Completed</Badge>;
//             case 'Cancelled': return <Badge bg="danger">Cancelled</Badge>;
//             default: return <Badge bg="warning">Unknown</Badge>;
//         }
//     };

//     const getAddressString = (address) => {
//         if (!address) return '-';
//         return [
//             address.customeraddress,
//             address.city?.cityname,
//             address.state?.statename,
//             address.pincode,
//             address.country?.countryname
//         ].filter(Boolean).join(', ');
//     };

//     // Fetch sales data
//     useEffect(() => {
//         const fetchSalesData = async () => {
//             try {
//                 const response = await axios.get(`${BASE_URL}salesReturn/findById/${id}`, {
//                     headers: authHeader(),
//                 });
//                 setSalesData(response.data);
//             } catch (error) {
//                 console.error("Error fetching sales data:", error);
//                 Swal.fire("Error", "Failed to load sales data", "error");
//                 navigate("/salesorderindex/1");
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchSalesData();
//     }, [id, navigate]);

//     if (isLoading) {
//         return (
//             <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
//                 <Spinner animation="border" variant="primary" />
//             </div>
//         );
//     }

//     if (!salesData) {
//         return (
//             <div className="container mt-4">
//                 <div className="alert alert-danger">Sales order not found</div>
//             </div>
//         );
//     }

//     return (
//         <div className="container-fluid mt-3">
//             {/* Invoice Information Card */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Invoice Information</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <Row>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Sales Return No.</label>
//                                 <div>{salesData.salesreturnno}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Sales Return Date</label>
//                                 <div>{formatDate(salesData.salesreturndate)}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Status</label>
//                                 <div className="border-bottom pb-1">{getStatusBadge(salesData.status)}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Invoice No.</label>
//                                 <div>{salesData.invoiceno}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Invoice Date</label>
//                                 <div>{formatDate(salesData.invoicedate)}</div>
//                             </div>
//                         </Col>

//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Tally Reference No.</label>
//                                 <div>{salesData.tallyreferenceno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Delivery Challan No.</label>
//                                 <div>{salesData.dcno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Delivery Challan Date</label>
//                                 <div>{formatDate(salesData.dcdate)}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Buyer Order No.</label>
//                                 <div>{salesData.buyerorderno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Buyer Order Date</label>
//                                 <div>{formatDate(salesData.buyerorderdate)}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Policy No.</label>
//                                 <div>{salesData.policyno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Valid Upto</label>
//                                 <div>{formatDate(salesData.validupto)}</div>
//                             </div>
//                         </Col>
//                         <Col md={8}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Reference</label>
//                                 <div>{salesData.reference || '-'}</div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card.Body>
//             </Card>

//             {/* Customer Information */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Customer Information</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <Row>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Customer Name</label>
//                                 <div>{salesData.customer?.companyname || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">GST No.</label>
//                                 <div>{salesData.customer?.gstno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Contact Person</label>
//                                 <div>{salesData.contactperson || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Phone</label>
//                                 <div>{salesData.contactno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Email</label>
//                                 <div>{salesData.email || '-'}</div>
//                             </div>
//                         </Col>
//                     </Row>

//                     {/* Bill To and Ship To */}
//                     <Row className="mt-3">
//                         <Col md={6}>
//                             <Card className="h-100">
//                                 <Card.Header className="bg-light">
//                                     <h6 className="mb-0">Bill To</h6>
//                                 </Card.Header>
//                                 <Card.Body>
//                                     {salesData.billto ? (
//                                         <>
//                                             <div className="mb-2">
//                                                 <strong>Address:</strong>
//                                                 <div className="border p-2 rounded bg-light">
//                                                     {getAddressString(salesData.billto)}
//                                                 </div>
//                                             </div>
//                                             <div>
//                                                 <strong>GST:</strong> {salesData.billto.gstno || '-'}
//                                             </div>
//                                         </>
//                                     ) : (
//                                         <div className="text-muted">No billing address specified</div>
//                                     )}
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                         <Col md={6}>
//                             <Card className="h-100">
//                                 <Card.Header className="bg-light">
//                                     <h6 className="mb-0">Ship To</h6>
//                                 </Card.Header>
//                                 <Card.Body>
//                                     {salesData.shipto ? (
//                                         <>
//                                             <div className="mb-2">
//                                                 <strong>Address:</strong>
//                                                 <div className="border p-2 rounded bg-light">
//                                                     {getAddressString(salesData.shipto)}
//                                                 </div>
//                                             </div>
//                                             <div>
//                                                 <strong>Contact:</strong> {salesData.shipto.contactperson || '-'}
//                                             </div>
//                                             <div>
//                                                 <strong>Phone:</strong> {salesData.shipto.contactno || '-'}
//                                             </div>
//                                         </>
//                                     ) : (
//                                         <div className="text-muted">No shipping address specified</div>
//                                     )}
//                                 </Card.Body>
//                             </Card>
//                         </Col>
//                     </Row>

//                     <Row className="mt-3">
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Payment Term</label>
//                                 <div>{salesData.paymentterm || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Freight</label>
//                                 <div>{salesData.freight || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Packing & Forwarding</label>
//                                 <div>{salesData.packingandforwarding || '-'}</div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card.Body>
//             </Card>

//             {/* Dispatch Information */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Dispatch Information</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <Row>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Dispatch Through</label>
//                                 <div>{salesData.dispatchthrough || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Destination</label>
//                                 <div>{salesData.destination || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Terms of Delivery</label>
//                                 <div>{salesData.termsofdelivery || '-'}</div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card.Body>
//             </Card>

//             {/* Branch Information */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Branch Information</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <Row>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Branch Name</label>
//                                 <div>{salesData.branch?.branchname || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Branch GST</label>
//                                 <div>{salesData.branch?.gstno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Contact Person</label>
//                                 <div>{salesData.branch?.contactperson || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Phone</label>
//                                 <div>{salesData.branch?.phoneno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Email</label>
//                                 <div>{salesData.branch?.email || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={12}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Address</label>
//                                 <div className="border p-2 rounded bg-light">
//                                     {[
//                                         salesData.branch?.address,
//                                         salesData.branch?.city,
//                                         salesData.branch?.state?.statename,
//                                         salesData.branch?.zipcode,
//                                         salesData.branch?.country?.countryname
//                                     ].filter(Boolean).join(', ')}
//                                 </div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card.Body>
//             </Card>
//             {/* Complete Warehouse Information */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Warehouse Information</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <Row>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Warehouse Name</label>
//                                 <div>{salesData.warehouse?.warehousename || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={6}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Warehouse Type</label>
//                                 <div>{salesData.warehouse?.warehousetype || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Contact Person</label>
//                                 <div>{salesData.warehouse?.contactperson || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Phone</label>
//                                 <div>{salesData.warehouse?.mobileno || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={4}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Email</label>
//                                 <div>{salesData.warehouse?.email || '-'}</div>
//                             </div>
//                         </Col>
//                         <Col md={12}>
//                             <div className="mb-3">
//                                 <label className="form-label fw-bold">Address</label>
//                                 <div className="border p-2 rounded bg-light">
//                                     {[
//                                         salesData.warehouse?.address,
//                                         salesData.warehouse?.city,
//                                         salesData.warehouse?.state?.statename,
//                                         salesData.warehouse?.zipcode,
//                                         salesData.warehouse?.country?.countryname
//                                     ].filter(Boolean).join(', ')}
//                                 </div>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Card.Body>
//             </Card>

//             {/* Products Table */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Products</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <div className="table-responsive">
//                         <Table striped bordered hover>
//                             <thead>
//                                 <tr>
//                                     <th>#</th>
//                                     <th>Description</th>
//                                     <th>Part No.</th>
//                                     <th>HSN</th>
//                                     <th>Serial No.</th>
//                                     <th>MOC</th>
//                                     <th>Type</th>
//                                     <th>Size</th>
//                                     <th>Qty</th>
//                                     <th>UOM</th>
//                                     <th>Unit Price</th>
//                                     <th>Amount</th>
//                                     <th>GST %</th>
//                                     <th>Total</th>
//                                     <th>Remarks</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {salesData.salesReturnItems?.map((item, index) => (
//                                     <tr key={index}>
//                                         <td>{index + 1}</td>
//                                         <td>{item.product?.description || '-'}</td>
//                                         <td>{item.partno || '-'}</td>
//                                         <td>{item.hsnsacno || '-'}</td>
//                                         <td>{item.serialnumber || '-'}</td>
//                                         <td>{item.product?.moc || '-'}</td>
//                                         <td>{item.product?.type || '-'}</td>
//                                         <td>{item.product?.size || '-'}</td>
//                                         <td >{item.quantity}</td>
//                                         <td>{item.uom || '-'}</td>
//                                         <td >{formatCurrency(item.unitrateinr)}</td>
//                                         <td >{formatCurrency(item.amount)}</td>
//                                         <td >{item.gst}</td>
//                                         <td >{formatCurrency(item.totalinr)}</td>
//                                         <td>{item.productremarks || '-'}</td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </Table>
//                     </div>
//                 </Card.Body>
//             </Card>

//             {/* Additional Charges */}
//             {salesData.additionalCharges?.length > 0 && (
//                 <Card className="mb-4">
//                     <Card.Header>
//                         <h5 className="mb-0">Additional Charges</h5>
//                     </Card.Header>
//                     <Card.Body>
//                         <div className="table-responsive">
//                             <Table striped bordered hover>
//                                 <thead>
//                                     <tr>
//                                         <th>#</th>
//                                         <th>Charge Type</th>
//                                         <th>Amount</th>
//                                         <th>GST %</th>
//                                         <th>Total</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody>
//                                     {salesData.additionalCharges.map((charge, index) => (
//                                         <tr key={index}>
//                                             <td>{index + 1}</td>
//                                             <td>{charge.chargetype}</td>
//                                             <td >{formatCurrency(charge.chargeamount)}</td>
//                                             <td >{charge.chargegst}</td>
//                                             <td >{formatCurrency(charge.chargetotal)}</td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </Table>
//                         </div>
//                     </Card.Body>
//                 </Card>
//             )}

//             {/* Summary Section */}
//             <Card className="mb-4">
//                 <Card.Header>
//                     <h5 className="mb-0">Sales Return Summary</h5>
//                 </Card.Header>
//                 <Card.Body>
//                     <div className="border p-3 bg-light rounded">
//                         <div className="d-flex justify-content-between mb-2">
//                             <span className="fw-bold">Products Total:</span>
//                             <span className="fw-bold">{formatCurrency(salesData.nettotalproduct)}</span>
//                         </div>
//                         {salesData.additionalCharges?.length > 0 && (
//                             <div className="d-flex justify-content-between mb-2">
//                                 <span className="fw-bold">Additional Charges:</span>
//                                 <span className="fw-bold">{formatCurrency(salesData.additionalchargestotal)}</span>
//                             </div>
//                         )}
//                         <div className="d-flex justify-content-between mb-2 border-top pt-2">
//                             <span className="fw-bold">Gross Total:</span>
//                             <span className="fw-bold">{formatCurrency(salesData.grosstotal)}</span>
//                         </div>
//                         <div className="d-flex justify-content-between border-top pt-2">
//                             <span className="fw-bold fs-5">Grand Total:</span>
//                             <span className="fw-bold fs-5">{formatCurrency(salesData.grandtotalproduct)}</span>
//                         </div>
//                     </div>
//                 </Card.Body>
//             </Card>

//             {/* Action Buttons */}
//             <div className="d-flex justify-content-end gap-2 mb-4">
//                 <Button variant="secondary" onClick={() => navigate(-1)}>
//                     <i className="bi bi-arrow-left me-2"></i>Back to List
//                 </Button>
//                 <Button variant="primary" onClick={() => navigate(`/salesorder/edit/${id}`)}>
//                     <i className="bi bi-pencil me-2"></i>Edit Sales Order
//                 </Button>
//             </div>
//         </div>
//     );
// }

// export default SalesMDView;




import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Col, Row, Table, Badge, Button, Card, Spinner, Container } from 'react-bootstrap';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import { FaArrowLeft, FaPrint, FaUndo } from 'react-icons/fa';

function SalesReturnView() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [salesReturnData, setSalesReturnData] = useState(null);

    // Helper functions
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-IN');
    };

    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) return '-';
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'Draft': return 'secondary';
            case 'Submitted': return 'primary';
            case 'Approved': return 'success';
            case 'Rejected': return 'danger';
            case 'Processed': return 'info';
            case 'Cancelled': return 'warning';
            default: return 'warning';
        }
    };

    const getAddressString = (address) => {
        if (!address) return '-';
        return [
            address.customeraddress,
            address.city?.cityname,
            address.state?.statename,
            address.pincode,
            address.country?.countryname
        ].filter(Boolean).join(', ');
    };

    // Fetch sales return data
    useEffect(() => {
        const fetchSalesReturnData = async () => {
            try {
                const response = await axios.get(`${BASE_URL}salesReturn/findById/${id}`, {
                    headers: authHeader(),
                });
                setSalesReturnData(response.data);
            } catch (error) {
                console.error("Error fetching sales return data:", error);
                Swal.fire("Error", "Failed to load sales return data", "error");
                navigate("/sales-return-list");
            } finally {
                setIsLoading(false);
            }
        };

        fetchSalesReturnData();
    }, [id, navigate]);

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (!salesReturnData) {
        return (
            <Container className="mt-4">
                <div className="alert alert-danger text-center">Sales return not found</div>
            </Container>
        );
    }

    return (
        <Container fluid className="p-3">
            {/* Header Section */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Body className="p-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h5 className="fw-bold text-primary mb-0">SALES RETURN - VIEW</h5>
                        <div className="d-flex gap-2">
                            {/* <button 
                                className="btn btn-outline-white btn-sm"
                                onClick={() => navigate(`/sales-return/print/${id}`)}
                            >
                                <FaPrint className="me-1" />
                                PRINT
                            </button> */}
                            <button className="btn btn-secondary btn-sm" onClick={() => navigate(-1)}>
                                <FaArrowLeft className="me-1" />
                                Back
                            </button>
                        </div>
                    </div>
                    
                    <Row className="g-2">
                        <Col md={3}>
                            <div className="border-start border-3 border-primary ps-2">
                                <small className="text-muted">Return No</small>
                                <div className="fw-bold">{salesReturnData.salesreturnno}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-success ps-2">
                                <small className="text-muted">Return Date</small>
                                <div className="fw-bold">{formatDate(salesReturnData.salesreturndate)}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-warning ps-2">
                                <small className="text-muted">Original Invoice</small>
                                <div className="fw-bold">{salesReturnData.invoiceno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className="border-start border-3 border-info ps-2">
                                <small className="text-muted">Status</small>
                                <div>
                                    <Badge 
                                        bg={getStatusBadge(salesReturnData.status)} 
                                        className="px-2 py-1"
                                    >
                                        {salesReturnData.status || '-'}
                                    </Badge>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Return Information */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Return Information</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Tally Reference No</small>
                                <div className="fw-bold">{salesReturnData.tallyreferenceno || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Delivery Challan No</small>
                                <div className="fw-bold">{salesReturnData.dcno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Buyer Order No</small>
                                <div className="fw-bold">{salesReturnData.buyerorderno || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Buyer Order Date</small>
                                <div className="fw-bold">{formatDate(salesReturnData.buyerorderdate)}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Policy No</small>
                                <div className="fw-bold">{salesReturnData.policyno || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Valid Upto</small>
                                <div className="fw-bold">{formatDate(salesReturnData.validupto)}</div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mt-2">
                                <small className="text-muted">Return Reason</small>
                                <div className="fw-bold">{salesReturnData.returnreason || '-'}</div>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="mt-2">
                                <small className="text-muted">Remarks</small>
                                <div className="fw-bold">{salesReturnData.remarks || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Customer Information */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Customer Information</h6>
                </Card.Header>
                <Card.Body className="p-3">
                    <Row className="g-3">
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Company Name</small>
                                <div className="fw-bold">{salesReturnData.customer?.companyname || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">GST No</small>
                                <div className="fw-bold">{salesReturnData.customer?.gstno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Contact Person</small>
                                <div className="fw-bold">{salesReturnData.contactperson || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Phone</small>
                                <div className="fw-bold">{salesReturnData.contactno || '-'}</div>
                            </div>
                        </Col>
                        <Col md={4}>
                            <div className="mb-2">
                                <small className="text-muted">Email</small>
                                <div className="fw-bold">{salesReturnData.email || '-'}</div>
                            </div>
                            <div>
                                <small className="text-muted">Payment Term</small>
                                <div className="fw-bold">{salesReturnData.customer?.paymentterm || '-'}</div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Bill To and Ship To */}
            <Row className="mb-3">
                <Col md={6}>
                    <Card className="shadow-sm border-0 rounded h-100">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 fw-bold">Bill To</h6>
                        </Card.Header>
                        <Card.Body className="p-3">
                            {salesReturnData.billto ? (
                                <>
                                    <div className="mb-2">
                                        <small className="text-muted">Address</small>
                                        <div className="fw-bold">{getAddressString(salesReturnData.billto)}</div>
                                    </div>
                                    <div>
                                        <small className="text-muted">GST</small>
                                        <div className="fw-bold">{salesReturnData.billto.gstno || '-'}</div>
                                    </div>
                                </>
                            ) : (
                                <div className="text-muted">No billing address specified</div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card className="shadow-sm border-0 rounded h-100">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 fw-bold">Ship To</h6>
                        </Card.Header>
                        <Card.Body className="p-3">
                            {salesReturnData.shipto ? (
                                <>
                                    <div className="mb-2">
                                        <small className="text-muted">Address</small>
                                        <div className="fw-bold">{getAddressString(salesReturnData.shipto)}</div>
                                    </div>
                                    <div className="mb-2">
                                        <small className="text-muted">Contact</small>
                                        <div className="fw-bold">{salesReturnData.shipto.contactperson || '-'}</div>
                                    </div>
                                    <div>
                                        <small className="text-muted">Phone</small>
                                        <div className="fw-bold">{salesReturnData.shipto.contactno || '-'}</div>
                                    </div>
                                </>
                            ) : (
                                <div className="text-muted">No shipping address specified</div>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Return Items Table */}
            <Card className="shadow-sm border-0 rounded mb-3">
                <Card.Header className="bg-light py-2">
                    <h6 className="mb-0 fw-bold">Return Items</h6>
                </Card.Header>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table bordered size="sm" className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th className="text-center fw-bold py-2">#</th>
                                    <th className="fw-bold py-2">Description</th>
                                    <th className="fw-bold py-2">Part No</th>
                                    <th className="fw-bold py-2">HSN Code</th>
                                    <th className="fw-bold py-2">Serial No</th>
                                    <th className="fw-bold py-2">MOC</th>
                                    <th className="fw-bold py-2">Type</th>
                                    <th className="fw-bold py-2">Size</th>
                                    <th className="fw-bold py-2 text-center">Return Qty</th>
                                    <th className="fw-bold py-2 text-center">UOM</th>
                                    <th className="fw-bold py-2 text-end">Unit Price</th>
                                    <th className="fw-bold py-2 text-end">Amount</th>
                                    <th className="fw-bold py-2 text-center">GST %</th>
                                    <th className="fw-bold py-2 text-end">Total</th>
                                    <th className="fw-bold py-2">Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {salesReturnData.salesReturnItems?.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td>
                                            <div className="fw-semibold">{item.product?.description || '-'}</div>
                                        </td>
                                        <td>{item.partno || '-'}</td>
                                        <td>{item.hsnsacno || '-'}</td>
                                        <td>{item.serialnumber || '-'}</td>
                                        <td>{item.product?.moc || '-'}</td>
                                        <td>{item.product?.type || '-'}</td>
                                        <td>{item.product?.size || '-'}</td>
                                        <td className="text-center">{item.quantity}</td>
                                        <td className="text-center">{item.uom || '-'}</td>
                                        <td className="text-end">{formatCurrency(item.unitrateinr)}</td>
                                        <td className="text-end">{formatCurrency(item.amount)}</td>
                                        <td className="text-center">{item.gst}%</td>
                                        <td className="text-end fw-bold">{formatCurrency(item.totalinr)}</td>
                                        <td>{item.productremarks || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot className="table-light">
                                <tr>
                                    <td colSpan="13" className="text-end fw-bold py-2">
                                        Return Items Total:
                                    </td>
                                    <td className="text-end fw-bold py-2" colSpan="2">
                                        {formatCurrency(salesReturnData.nettotalproduct)}
                                    </td>
                                </tr>
                            </tfoot>
                        </Table>
                    </div>
                </Card.Body>
            </Card>

            {/* Additional Charges */}
            {salesReturnData.additionalCharges?.length > 0 && (
                <Card className="shadow-sm border-0 rounded mb-3">
                    <Card.Header className="bg-light py-2">
                        <h6 className="mb-0 fw-bold">Additional Charges</h6>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <div className="table-responsive">
                            <Table bordered size="sm" className="mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="fw-bold py-2">#</th>
                                        <th className="fw-bold py-2">Charge Type</th>
                                        <th className="fw-bold py-2 text-end">Amount</th>
                                        <th className="fw-bold py-2 text-center">GST %</th>
                                        <th className="fw-bold py-2 text-end">Total</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {salesReturnData.additionalCharges.map((charge, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{index + 1}</td>
                                            <td>{charge.chargetype}</td>
                                            <td className="text-end">{formatCurrency(charge.chargeamount)}</td>
                                            <td className="text-center">{charge.chargegst}%</td>
                                            <td className="text-end fw-bold">{formatCurrency(charge.chargetotal)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot className="table-light">
                                    <tr>
                                        <td colSpan="4" className="text-end fw-bold py-2">
                                            Charges Total:
                                        </td>
                                        <td className="text-end fw-bold py-2">
                                            {formatCurrency(salesReturnData.additionalchargestotal)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            )}

            {/* Summary Section */}
            <Row>
                <Col lg={6} className="ms-auto">
                    <Card className="shadow-sm border-0 rounded">
                        <Card.Header className="bg-light py-2">
                            <h6 className="mb-0 fw-bold text-center">Return Summary</h6>
                        </Card.Header>
                        <Card.Body className="p-3">
                            <div className="space-y-2">
                                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                    <span className="fw-semibold">Return Items Total:</span>
                                    <span className="fw-bold">{formatCurrency(salesReturnData.nettotalproduct)}</span>
                                </div>
                                
                                {salesReturnData.additionalCharges?.length > 0 && (
                                    <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                        <span className="fw-semibold">Additional Charges:</span>
                                        <span className="fw-bold">{formatCurrency(salesReturnData.additionalchargestotal)}</span>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center py-1 border-bottom">
                                    <span className="fw-semibold">Gross Total:</span>
                                    <span className="fw-bold">{formatCurrency(salesReturnData.grosstotal)}</span>
                                </div>

                                <div className="d-flex justify-content-between align-items-center py-2 border-top">
                                    <span className="fw-bold text-danger">Refund Amount</span>
                                    <span className="fw-bold text-danger fs-5">{formatCurrency(salesReturnData.grandtotalproduct)}</span>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* Footer Actions */}
            <div className="text-center mt-3 pt-2 border-top">
                <button 
                    className="btn btn-secondary btn-sm me-2"
                    onClick={() => navigate(-1)}
                >
                    <FaArrowLeft className="me-1" />
                    Back to List
                </button>
                {/* <button 
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate(`/sales-return/edit/${id}`)}
                >
                    <FaUndo className="me-1" />
                    Edit Return
                </button> */}
            </div>
        </Container>
    );
}

export default SalesReturnView;
